function initPLPCards() {
    const productCardSliders = document.querySelectorAll('.maje-product-wrapper .swiper');

    productCardSliders.forEach(customSwiper => {
        const nextBtn = customSwiper.querySelector('.swiper-button-next');
        const prevBtn = customSwiper.querySelector('.swiper-button-prev');

        const swiper = new Swiper(customSwiper, {
            loop: true,
            draggable: true,
            slidesPerView: 1,
            speed: 1000,
            navigation: {
              nextEl: nextBtn,
              prevEl: prevBtn,
            },
        });
    })

    // productCardSlider.forEach(customSwiper => {
    //     const swiperParams = {
    //         slidesPerView: 1,
    //     };

    //     Object.assign(customSwiper, swiperParams);

    //     customSwiper.initialize();
    // })
}

if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initPLPCards);
}

// if (window.innerWidth > 758) {
    initPLPCards();
// }